import AppDialog from "./AppDialog";
import { Button } from "@/components/ui/button";

const TONE_TITLE_CLASSNAME = {
  danger: "text-destructive",
  success: "text-emerald-600",
  warning: "text-amber-600",
  info: "text-primary",
};

const TONE_BUTTON_CLASSNAME = {
  success:
    "bg-emerald-600 text-white border-transparent hover:bg-emerald-600/90 dark:bg-emerald-600 dark:text-white dark:border-transparent dark:hover:bg-emerald-600/90",
  warning:
    "bg-amber-500 text-white border-transparent hover:bg-amber-500/90 dark:bg-amber-500 dark:text-white dark:border-transparent dark:hover:bg-amber-500/90",
};

const ConfirmDialog = ({
  open,
  onOpenChange,
  title,
  description,
  icon,
  children,
  confirmLabel,
  cancelLabel,
  onConfirm,
  loading = false,
  tone = "default",
  size = "sm",
}) => {
  const confirmVariant = tone === "danger" ? "destructive" : "default";
  const titleColor = TONE_TITLE_CLASSNAME[tone] || "";

  return (
    <AppDialog
      open={open}
      onOpenChange={onOpenChange}
      title={<p className={titleColor}>{title}</p>}
      icon={icon}
      size={size}
      footer={
        <>
          <Button
            variant="outline"
            onClick={() => onOpenChange?.(false)}
            disabled={loading}
          >
            {cancelLabel}
          </Button>
          <Button
            variant={confirmVariant}
            className={TONE_BUTTON_CLASSNAME[tone]}
            onClick={onConfirm}
            disabled={loading}
          >
            {confirmLabel}
          </Button>
        </>
      }
    >
      {children || (
        <p className="text-sm text-muted-foreground">{description}</p>
      )}
    </AppDialog>
  );
};

export default ConfirmDialog;
